import type { User } from "@/users/types";
import { apiClient } from "./apiClient";

export const meGateway = {
  async getMe(): Promise<User> {
    return await apiClient.get("/api/users/me");
  },
};
